import { useGuestToken } from '~/composables/useGuestToken'

/** Guest favorites persisted in a cookie bound to the current guest token. */
export const useGuestFavoritesCookie = () => {
  const { getGuestToken } = useGuestToken()

  const guestFavoritesCookie = useCookie<{ token: string | null; favorites: number[] }>(
    'mealz-guest-favorites',
    {
      default: () => ({ token: null, favorites: [] }),
      maxAge: 60 * 60 * 24 * 30, // 30 days
      path: '/',
      sameSite: 'lax'
    }
  )

  // A cookie without a token is a new session; otherwise it must match the current guest token.
  // The current token is read first because reading it mints one for a guest that has none.
  const isValidGuestCookie = (): boolean => {
    const currentToken = getGuestToken()
    const cookieToken = guestFavoritesCookie.value.token
    if (cookieToken == null || cookieToken === '') return true

    return cookieToken === currentToken
  }

  const writeGuestFavorites = (favorites: number[]): void => {
    guestFavoritesCookie.value = { token: getGuestToken(), favorites }
  }

  const resetGuestFavorites = (): void => {
    writeGuestFavorites([])
  }

  return { guestFavoritesCookie, isValidGuestCookie, writeGuestFavorites, resetGuestFavorites }
}
